const routes = require('./routes');

const routeDict = routes.reduce((acc, route) => {
  acc[route.name] = route.pattern;
  return acc;
}, {});

/**
 * Retrieves the route path based on the provided parameters.
 * @param {Object} params - The parameters for generating the route path.
 * @param {string} params.routeName - The name of the route.
 * @param {string} params.locale - The locale for the route.
 * @param {Object} params.params - The route parameters.
 * @returns {string} The generated route path.
 */
export const getRoutePath = (params) => {
  const { routeName = '', locale = '', params: routeParams = {} } = params;
  const { redirect: redirectUrl = '' } = routeParams;

  if (!routeDict[routeName]) return '/404';

  let routePattern = routeDict[routeName];
  Object.keys(routeParams).forEach((key) => {
    const value = routeParams[key];
    routePattern = routePattern.replace(`:${key}`, value);
  });

  let routePath = `/${locale}${routePattern}`;

  if (redirectUrl) {
    routePath += `?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return routePath;
};

/**
 * Given a routeName url pattern, replace all parameter segments with the specified character
 * @param {Object} params - The parameters replacement.
 * @param {string} params.routeName - The name of the route (e.g. /bookings/:bookingId).
 * @param {string} params.replacement - The replacement character for the matched parameter segments
 * @returns {string} The new route string
 * @example ```
 * replaceRouteParams({routeName: '/bookings/:bookingId', replacement: '*' })
 * returns 'bookings/*'
 */
export const replaceRouteParams = (params) => {
  const { routeName, replacement = '' } = params;
  return routeName.replace(/:[^/]*/g, replacement);
};

/**
 * Given a url string, replace all numeric segments with the specified character
 * @param {Object} params - The parameters replacement.
 * @param {string} params.routeName - The name of the route (e.g. /bookings/81382).
 * @param {string} params.replacement - The replacement character for the matched parameter segments
 * @returns {string} The new route string
 * @example ```
 * replaceRouteParams({routeName: '/bookings/1234', replacement: '*' })
 * returns 'bookings/*'
 */
export const replaceUrlIdParams = (params) => {
  const { url, replacement = '' } = params;
  return url.replace(/\d+/g, replacement);
};
